module.exports = __webpack_public_path__ + "img/rt_sample.62d08efd.png";